export const NAME = 'onboarding';

export enum ONBOARDING_STEPS {
  GAMES = 'games',
  RESOURCES = 'resources',
  REWARDS = 'rewards',
}
